<template>
  <div class="rate-card">
    <div class="d-flex align-items-center justify-content-between">
      <span @click="getRateCardDetails"
        ><strong>{{ rateCard.title }}</strong></span
      >
      <div>
        <div
          v-if="rateCard.activeCurrencies && rateCard.activeCurrencies.length"
          class="currency-container"
        >
          <div v-for="c in rateCard.activeCurrencies" :key="c" class="currency">
            {{ c }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="show_rate_card_set_details">
      <table class="table table-bordered table-sm mt-4">
        <thead>
          <tr>
            <th>Role</th>
            <th v-for="c in rateCard.activeCurrencies" :key="c">
              {{ c }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rate, index) in rateCard.roleRates" :key="index">
            <td>{{ rate.role }}</td>
            <td v-for="c in rateCard.activeCurrencies" :key="c">
              {{ rate.rates[c] / 100 }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mt-4">
        <template v-if="!show_details_container">
          <div class="d-flex justify-content-end">
            <button
              class="btn text-white primary-bg-color"
              @click="show_details_container = !show_details_container"
            >
              Add New Carrier - Lawfirm Mapping
            </button>
          </div>
        </template>
        <template v-else>
          <div class="details-container">
            <div class="d-flex flex-wrap gap-1">
              <font-awesome-icon
                class="close_details_icon text-danger"
                :icon="['fas', 'times-circle']"
                @click="show_details_container = !show_details_container"
              />
              <div>
                <label for="">Carrier</label>
                <select
                  name=""
                  id=""
                  class="custom-select"
                  v-model.trim="carrier"
                >
                  <option value="">All Carriers</option>
                  <option
                    :value="carrier.label"
                    v-for="carrier in carriers"
                    :key="carrier.id"
                  >
                    {{ carrier.label }}
                  </option>
                </select>
              </div>
              <div>
                <label for="">Lawfirm</label>
                <select
                  name=""
                  id=""
                  class="custom-select"
                  v-model.trim="lawfirm"
                >
                  <option value="">All Lawfirms</option>
                  <option
                    :value="lawfirm.name"
                    v-for="lawfirm in lawfirms"
                    :key="lawfirm.id"
                  >
                    {{ lawfirm.name }}
                  </option>
                </select>
              </div>
              <div>
                <label for="">Commission Percentage</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="commission_percentage"
                  :class="{
                    invalid:
                      commission_percentage < 0 || commission_percentage > 100,
                  }"
                />
              </div>
              <div>
                <label for="">Cap Amount</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="cap_amount"
                />
              </div>
              <div>
                <label for="">Comments</label>
                <textarea
                  class="form-control"
                  cols="60"
                  v-model="comments"
                ></textarea>
              </div>
            </div>
            <div class="mt-4 d-flex justify-content-end">
              <button
                class="btn text-white primary-bg-color"
                @click="saveMapping"
              >
                Save Mapping
              </button>
            </div>
          </div>
        </template>
      </div>
      <div v-if="rateCard.mappings && rateCard.mappings.length" class="mt-3">
        <h5 class="text-center primary-color text-underline">
          Carrier - Lawfirm Mappings
        </h5>
        <table class="table table-bordered table-sm mt-3">
          <thead>
            <tr>
              <th>Carrier</th>
              <th>Lawfirm</th>
              <th>Cap Amount</th>
              <th>Commission Percentage</th>
              <th>Comments</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mapping in rateCard.mappings" :key="mapping.id">
              <td>{{ mapping.carrier.name }}</td>
              <td>{{ mapping.lawfirm.name }}</td>
              <td>{{ mapping.capAmount }}</td>
              <td>{{ mapping.commissionPercentage }}</td>
              <td>{{ mapping.comments }}</td>
              <td>
                <font-awesome-icon
                  class="text-danger"
                  :icon="['fas', 'times-circle']"
                  @click="removeMapping(rateCard.rateCardId, mapping.id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="mt-3"
        v-if="rateCard.taskMappings && rateCard.taskMappings.length"
      >
        <h5 class="text-center primary-color text-underline">
          Role - Tasks Mappings
        </h5>
        <table class="table table-bordered table-sm mt-3">
          <thead>
            <tr>
              <th>Role</th>
              <th>Tasks</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="taskMapping in rateCard.taskMappings"
              :key="taskMapping.id"
            >
              <td style="width: 10%">{{ taskMapping.role }}</td>
              <td style="width: 90%">
                <div class="d-flex flex-wrap gap-1 justify-content-center">
                  <div
                    v-for="task in taskMapping.tasks"
                    :key="task"
                    class="task"
                    :class="
                      isDefaultTask(taskMapping.role, task)
                        ? 'text-white primary-bg-color'
                        : ''
                    "
                    :title="
                      isDefaultTask(taskMapping.role, task)
                        ? 'Default Mapping'
                        : ''
                    "
                  >
                    {{ task }}
                    <font-awesome-icon
                      :icon="['fas', 'times-circle']"
                      class="ml-2 text-danger"
                      v-if="!isDefaultTask(taskMapping.role, task)"
                      @click="removeTask(taskMapping.role, task)"
                    />
                  </div>
                  <div
                    class="position-relative add-task d-flex align-items-center"
                    v-if="temp_tasks && temp_tasks.length"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'plus-circle']"
                      size="lg"
                    />
                    <ul class="tasks-container">
                      <li
                        v-for="task in temp_tasks"
                        :key="task"
                        @click="addTask(taskMapping.role, task, $event)"
                      >
                        {{ task }}
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <td colspan="2">
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-sm text-white primary-bg-color"
                  @click="updateRateCardTaskMapping()"
                >
                  Update Role Tasks Mappings
                </button>
              </div>
            </td>
          </tfoot>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import rateCardService from "@/services/rateCardService";
import { mapState } from "vuex";
import { EventBus } from "@/EventBus";
export default {
  name: "RateCard",
  props: ["rateCardId"],
  computed: {
    ...mapState({
      customFields: (state) => state.customFields,
      lawfirms: (state) => state.lawfirms,
      tasks: (state) => state.tasks,
      roleTasksMasterMappings: (state) => state.roleTasksMasterMappings,
    }),
    rateCard() {
      return this.$store.getters.rateCardById(this.rateCardId);
    },
    carriers() {
      const carrier_custom_field_id = 598475;
      return this.$store.getters.customFieldById(carrier_custom_field_id)
        .choices;
    },
  },
  created() {},
  methods: {
    getRateCardDetails(e) {
      const ratecard_set_versionid = this.getLatestRateCardSetVersionId();
      if (!this.show_rate_card_set_details) {
        EventBus.$emit("toast", {
          title: "",
          message: "Fetching Rate Cards Details & Mappings",
          variant: "success",
        });
        rateCardService
          .getRateCardDetails(this.rateCard.id, ratecard_set_versionid)
          .then((response) => {
            e.target.closest(".rate-card").classList.toggle("active");
            this.$store.commit("updateRateCard", response.data.data);
            this.show_rate_card_set_details = true;
            const mappedServices = this.rateCard.taskMappings.flatMap((m) => {
              if (m.tasks) {
                return m.tasks;
              }
            });
            this.temp_tasks = [...this.tasks].filter(
              (t) => !mappedServices.includes(t)
            );
          });
      } else {
        this.show_rate_card_set_details = false;
        e.target.closest(".rate-card").classList.toggle("active");
      }
    },
    getLatestRateCardSetVersionId() {
      const rate_card_integers = this.rateCard.rateCardSetVersionIds.map((r) =>
        Number(r)
      );
      rate_card_integers.sort((a, b) => a - b);
      return rate_card_integers.slice(-1);
    },
    saveMapping() {
      const commissionPercentage = Number(this.commission_percentage);
      if (commissionPercentage < 0 || commissionPercentage > 100) {
        return false;
      }
      const input = {
        lawfirm: { name: this.lawfirm },
        carrier: { name: this.carrier },
        capAmount: this.cap_amount,
        commissionPercentage,
        comments: this.comments,
      };
      EventBus.$emit("toast", {
        title: "",
        message: "Adding new Rate Card Mapping",
        variant: "success",
      });
      rateCardService
        .addRateCardMapping(this.rateCard.rateCardId, input)
        .then((response) => {
          let that = this;
          EventBus.$emit("toast", {
            title: "",
            message: "New Rate Card Mapping Added Successfully",
            variant: "success",
          });
          this.$store.commit("updateRateCardCarrierLawFirmMappings", {
            id: response.data.data.id,
            mappings: response.data.data.mappings,
          });
          //this.$store.commit("updateRateCard", response.data.data);
          //this.$emit("updateRateCard", response.data.data, function () {
          that.carrier = "";
          that.lawfirm = "";
          that.cap_amount = "";
          that.commission_percentage = "";
          that.comments = "";
          that.show_details_container = false;
          //});
        });
    },
    removeMapping(rateCardId, mappingId) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to remove the mapping.", {
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            EventBus.$emit("toast", {
              title: "",
              message: "Removing new Rate Card Mapping",
              variant: "success",
            });
            rateCardService
              .removeMapping(rateCardId, mappingId)
              .then((response) => {
                EventBus.$emit("toast", {
                  title: "",
                  message: "Removed Rate Card Mapping",
                  variant: "success",
                });
                this.$store.commit("updateRateCardCarrierLawFirmMappings", {
                  id: response.data.data.id,
                  mappings: response.data.data.mappings,
                });
              });
          }
        });
    },
    getTasksAssociatedForRole(role) {
      if (this.rateCard.taskMappings) {
        const cur_role = this.rateCard.taskMappings.find(
          (m) => m.role === role
        );
        if (cur_role) {
          return cur_role.tasks;
        }
      }
      return [];
    },
    removeTask(role, task) {
      const original_index = this.tasks.findIndex((t) => t === task);
      this.temp_tasks.splice(original_index, 0, task);
      const index = this.rateCard.taskMappings.findIndex(
        (t) => t.role === role
      );
      const taskMapping = this.rateCard.taskMappings[index];
      taskMapping.tasks = taskMapping.tasks.filter((t) => t !== task);
      this.rateCard.taskMappings.splice(index, 1, taskMapping);
    },
    addTask(role, task, e) {
      const index = this.temp_tasks.findIndex((t) => t == task);
      this.temp_tasks.splice(index, 1);
      if (this.rateCard.taskMappings) {
        const mappingIndex = this.rateCard.taskMappings.findIndex(
          (t) => t.role === role
        );
        if (mappingIndex === -1) {
          this.rateCard.taskMappings.push({
            role,
            tasks: [task],
          });
        } else {
          const taskMapping = this.rateCard.taskMappings[mappingIndex];
          taskMapping.tasks.push(task);
          this.rateCard.taskMappings.splice(mappingIndex, 1, taskMapping);
        }
      } else {
        this.rateCard.taskMappings = [
          {
            role,
            tasks: [task],
          },
        ];
      }
      this.$store.commit("updateRateCard", this.rateCard);
    },
    updateRateCardTaskMapping() {
      EventBus.$emit("toast", {
        title: "",
        message: "Updating Rate Card",
        variant: "success",
      });
      rateCardService
        .updateRateCardTaskMapping(this.rateCard)
        .then((response) => {
          this.$store.commit("updateRateCardTaskMappings", {
            id: response.data.data.id,
            mappings: response.data.data.taskMappings,
          });
          EventBus.$emit("toast", {
            title: "",
            message: "Updated Rate Card Task Mappings Successfully",
            variant: "success",
          });
        });
    },
    isDefaultTask(role, task) {
      const mapping = this.roleTasksMasterMappings.find((r) => r.role === role);
      if (mapping) {
        if (mapping.tasks) {
          return mapping.tasks.includes(task);
        }
      }
      return false;
    },
  },
  data() {
    return {
      show_rate_card_set_details: false,
      rate_card_set_details: [],
      show_details_container: false,
      show_tasks_mapping_container: false,
      carrier: "",
      lawfirm: "",
      cap_amount: "",
      commission_percentage: "",
      comments: "",
      temp_tasks: [],
    };
  },
};
</script>
<style scoped lang="scss">
.rate-card {
  padding: 18px 20px;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px -3px 5px #edf2f450;
  font-weight: bold;
  span {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

.rate-card.active {
  box-shadow: inset 3px 3px 5px rgba(0, 0, 0, 0.05),
    inset -3px -3px 5px #edf2f450;
}

.currency-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  pointer-events: none !important;
  .currency {
    padding: 3px 10px;
    border-radius: 20px;
    background-color: $primary-color;
    color: white;
  }
}

table {
  td,
  th {
    text-align: center;
  }
  td:first-child {
    vertical-align: middle;
  }
  th {
    background-color: $primary-color;
    color: #fff;
  }
}

.details-container {
  border: 1px solid $primary-color;
  padding: 30px 20px;
  position: relative;
  .close_details_icon {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
}

.form-control {
  &:focus {
    box-shadow: none;
  }
}

.invalid {
  border-color: red !important;
}

.add-task:hover {
  .tasks-container {
    opacity: 1;
    transform: scale(1);
    transform-origin: top right;
  }
}

.tasks-container {
  list-style-type: none;
  height: 250px;
  width: 250px;
  overflow: auto;
  border: 1px solid $primary-color;
  background-color: #fff;
  border-radius: 5px;
  z-index: 99;
  padding: 10px 10px;
  position: absolute;
  right: 5px;
  top: 23px;
  opacity: 0;
  transform: scale(0);
  transform-origin: top right;
  transition: all 0.5s ease;
  li {
    padding: 5px 0px;
    border-bottom: 1px solid $primary-color;
    cursor: pointer;
    &:hover {
      background: $secondary-color;
      color: white;
    }
  }
}

.task {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 25px;
  background: white;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1), -3px -3px 5px #edf2f450;
  color: #2b2d42;
  position: relative;
}
</style>